import UserPaymentMethodMapper from '@web/mapper/UserPaymentMethodMapper'
import { UserPaymentMethod } from '@web/types/UserPaymentMethod'
import client, { ApiVersion } from '@web/api/client'

export default class UserPaymentMethodApi {
  static async fetchAll (): Promise<UserPaymentMethod[]> {
    const response = await client.get('/user-payment-method', {
      apiVersion: ApiVersion.v2
    })
    return response.data.data.map(item => UserPaymentMethodMapper.toClient(item))
  }

  static async remove (id: number) {
    return client.delete(`/user-payment-method/${id}`, ApiVersion.v2)
  }
}
